import React, { Component } from 'react';
import { Toast, ToastContainer } from 'react-bootstrap';
import Dropdown from 'react-bootstrap/Dropdown';

import { Navigate } from 'react-router-dom';
import './group-menu.css';
import { MemberProfile } from '../PlayerManagement/Profile';
import { DiscordContext } from '../../discord/DiscordContext';
import { getLocalDisplayName } from '../../hooks/useLocalDisplayName';

class InviteToGroupButton extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            onlineFriends: []
        };
    }

    getList = () => {
        let typeName = 'Group';
        let packageValue = { type: 'List', data: { type: 'list' } };
        this.props.app.state.authenticator.sendMessage(typeName, packageValue);
    };

    receiveList = (receivedMessage) => {
        // CC_RETIRE_LFG_TOGGLE (2026-06-07): Group/List is a friends-only
        // invite roster now. The `users` (lfg=True rando) leg is retired.
        let friends = receivedMessage.package.data.friends;
        this.setState({
            onlineFriends: friends
        });

    };

    onToggleHandler = (isOpen, e) => {
        this.setState({ isOpen: isOpen });
    };

    invite = (user) => {
        let typeName = 'Group';
        let packageValue = { type: 'Invite', data: { user: user.id } };
        this.props.app.state.authenticator.sendMessage(typeName, packageValue);
    };


    render() {
        let userId = this.props.app.state.authenticator.account.user.id;
        return <>
            <div id={'invite-to-group-button-wrapper'} className={'invite-to-group-button-wrapper'}>
                <Dropdown
                    // autoClose="outside"
                    show={this.state.isOpen}
                    onToggle={this.onToggleHandler}
                >
                    <Dropdown.Toggle
                        variant={'secondary'}
                        id="invite-to-group-button"
                        className={'invite-to-group-button'}
                    >
                        <div id={'self'} className={'group-menu-add'} onClick={this.getList}>
                            <div id={'letter'} className={'group-menu-plus'}>+</div>
                        </div>
                    </Dropdown.Toggle>
                    <Dropdown.Menu className={'invite-to-group-menu-container'}>
                        {/* <h3 style={{ padding: '0.25rem 1rem' }}>Invite To Group</h3> */}
                        {this.state.onlineFriends.map(
                            (friend, friendIndex) => {
                                return <Dropdown.Item
                                    key={friendIndex}
                                    className={'invite-to-group-dropdown-menu-item'}
                                    onClick={() => {
                                        this.invite(friend);
                                    }}
                                >
                                    {friend.display_name}
                                </Dropdown.Item>;
                            })}
                    </Dropdown.Menu>
                </Dropdown></div>

        </>;
    }
}


class IndividualMenu extends Component {
    // Discord context so getLocalDisplayName can resolve nick →
    // global_name → @handle for the local user instead of bottoming
    // out at the discord_<snowflake> username.
    static contextType = DiscordContext;

    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            showProfile: false
        };
    }

    leave = () => {
        this.props.app.game.returnToMenu(this.props.location.pathname);
    }

    onToggleHandler = (isOpen, e) => {
        this.setState({ isOpen: isOpen });
    };

    showProfile = () => {
        window.dispatchEvent(new Event('show-profile-event'));
    };

    render() {
        let displayName = getLocalDisplayName(this.props.app, this.context);
        let firstLetter = displayName[0];
        let userId = this.props.app.state.authenticator.account.user.id;
        return <>
            <div id={'individual-menu-wrapper'}>
                <Dropdown
                    // autoClose="outside"
                    show={this.state.isOpen}
                    onToggle={this.onToggleHandler}
                >
                    <Dropdown.Toggle
                        id="individual-Menu-button"
                        className={'remove-after individual-menu-dropdown-toggle'}
                    >
                        <div id={'self'} className={'group-menu-self'} onClick={this.individualMenu}>
                            <div id={'rank'} className={'individual-rank-anchor'}>
                                <div id={'individual-rank-anchor'}
                                     className={'individual-rank-value'}>
                                    {this.props.userMember && this.props.userMember.user.rank}
                                </div>
                            </div>
                            <div id={'letter'} className={'group-menu-letter'}>{firstLetter}</div>
                        </div>
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                        {this.props.members.length > 1 &&
                            <Dropdown.Item onClick={this.leave}>
                                Leave Group
                            </Dropdown.Item>
                        }
                        <Dropdown.Item onClick={this.showProfile}>
                            Profile
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </div>
        </>;
    }
}


class MemberMenu extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isOpen: false
        };
        this.profileModal = null;
    }

    onToggleHandler = (isOpen, e) => {
        this.setState({ isOpen: isOpen });
    };

    kick = () => {
        let typeName = 'Group';
        let packageValue = {
            type: 'Kick',
            data: {
                type: 'kick',
                user: this.props.displayMember.user.id
            }
        };
        this.props.app.state.authenticator.sendMessage(typeName, packageValue);
    }

    addFriend = () => {
        let typeName = 'Friend';
        let packageValue = {
            type: 'Invite', data: {
                type: 'invite', email: this.state.email
            }
        };
        this.props.app.state.authenticator.sendMessage(typeName, packageValue);
    }

    showProfile = () => {
        this.profileModal.show();
    }


    render() {
        let member = this.props.displayMember;
        let firstLetter = member.user.display_name[0];

        return <>
            <MemberProfile {...this.props}
                           member={member}
                           ref={(ref) => this.profileModal=ref }
            />
            <div id={'individual-menu-wrapper'}>
                <Dropdown
                    // autoClose="outside"
                    show={this.state.isOpen}
                    onToggle={this.onToggleHandler}
                >
                    <Dropdown.Toggle
                        id="individual-Menu-button"
                        className={'remove-after individual-menu-dropdown-toggle'}
                    >
                        <div id={'self'} className={'group-menu-member'} onClick={this.memberMenu}>
                            <div id={'rank'} className={'individual-rank-anchor'}>
                                <div id={'member-rank-value'}
                                     className={'member-rank-value'}>
                                    {member.user.rank}
                                </div>
                            </div>
                            <div id={'letter'} className={'group-menu-letter-small'}>{firstLetter}</div>
                        </div>
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                        <Dropdown.Item onClick={this.kick}>
                            Kick
                        </Dropdown.Item>
                        <Dropdown.Item onClick={this.showProfile}>
                            Profile
                        </Dropdown.Item>
                        <Dropdown.Item onClick={this.addFriend}>
                            Add Friend
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </div>
        </>;
    }
}


class InvitationToast extends Component {

    constructor(props) {
        super(props);
        this.state = {
            show: true
        };
    }

    acceptInvitation = () => {
        this.props.acceptInvitation();
    };

    declineInvitation = () => {
        this.props.declineInvitation();
    };

    render() {
        return <>
            <ToastContainer className="p-3"
                            position={'middle-end'}
                            id={'toaster'}
                            style={{ zIndex: 201 }}
                // onClick={this.props.closeToast}
            >
                <Toast id={'invitation-toast'}
                    // show={this.props.showToast}
                       onClose={this.declineInvitation}
                    // className={'ftue-toast'}
                >
                    <Toast.Header
                        id={'invitation-header'}
                        closeButton={true}
                        // closeVariant={'white'}
                        // className={'ftue-toast-header'}
                    >
                        <div className="me-auto">
                            Group Invitation
                        </div>
                        {/* <strong className="me-auto">FTUE</strong> */}
                        {/* <small>11 mins ago</small> */}
                    </Toast.Header>
                    <Toast.Body className={'ftue-toast-body'} onClick={this.acceptInvitation}>
                        {/* <span dangerouslySetInnerHTML={{ __html: message }}/> */}
                        Click to Join
                    </Toast.Body>
                </Toast>
            </ToastContainer>
        </>;
    }

}

export default class GroupMenu extends Component {

    constructor(props) {
        super(props);
        const groupHandler = this.props.app.game.groupHandler;
        this.state = {
            members: groupHandler.groupMembers,
            member: groupHandler.memberRecord,
            invitation: null,
            launch: null,
            // CC_FRIENDS_INVITE_FROM_LOBBY: after accepting an invite we
            // joinGroup and wait for the inviter's lobby uuid to arrive on
            // the next group-update-event (groupEvent stashes it into
            // state.lobbyUuid), then route to /game/:lobbyUuid — the
            // canonical lobby surface. `lobbyUuid` is cleared on accept so
            // a stale prior uuid can't navigate before the new join lands.
            joining: false,
            lobbyUuid: null
        };

        this.mainButton = null;
        this.friendsButton = null;
        this.inviteToGroupButton = null;
    }

    componentDidMount() {
        window.addEventListener('group-update-event',
            this.groupEvent);
        window.addEventListener('game-invitation-event',
            this.invited);
        window.addEventListener('invitables-event',
            this.invitables);
    }

    componentWillUnmount() {
        window.removeEventListener('group-update-event',
            this.groupEvent);
        window.removeEventListener('game-invitation-event',
            this.invited);
        window.removeEventListener('invitables-event',
            this.invitables);
    }

    groupEvent = (e) => {
        const newState = e.detail;
        this.setState(newState);
    }

    getList = () => {
        let typeName = 'Group';
        let packageValue = { type: 'List', data: { type: 'list' } };
        this.props.app.state.authenticator.sendMessage(typeName, packageValue);
    };

    invitables = (e) => {
        // CC_FRIENDS_LFG_E2E: `GameGroupHandler.list` dispatches this
        // window event with the parsed Group/List payload. Forward to
        // `this.list` (which the existing code wires to
        // `inviteToGroupButton.receiveList`). Until this listener
        // landed, Group/List responses fired into the void and the
        // "+" dropdown's onlineFriends went stale the moment any peer
        // changed state.
        const detail = e.detail || {};
        // CC_RETIRE_LFG_TOGGLE (2026-06-07): the roster is friends-only
        // now — the retired `users`/lfg leg is gone. Reshape the friends
        // list into the Channels envelope `receiveList` already reads.
        const synthetic = {
            package: { data: { friends: detail.friends } },
        };
        this.list(synthetic);
    };

    launch = (receivedMessage) => {
        let game = receivedMessage.package.data.game;
        let seat = receivedMessage.package.data.seat;
        this.setState({ launch: { game: game, seat: seat } });
    };

    // join = (receivedMessage) => {
    //     console.log('joined group', receivedMessage.package.data.members);
    //     this.setState({ members: receivedMessage.package.data.members },
    //         this.notifyPlayMenuMembers
    //     );
    // };

    invited = (e) => {
        this.setState({ invitation: e.detail });
    };

    // notifyPlayMenuMembers = () => {
    //     this.props.app.playMenu && this.props.app.playMenu.updateMembers(
    //         this.state.members
    //     );
    // };

    acceptInvitation = () => {
        let group = this.state.invitation.group;
        console.log('Accept Invitation', group);

        // Existing join rail: joinGroup binds this connection to the
        // inviter's lobby; the backend then broadcasts Members, which
        // arrives here as a group-update-event carrying lobby_uuid.
        this.props.app.game.gameApi.joinGroup(group);

        // CC_FRIENDS_INVITE_FROM_LOBBY: arm the post-join navigate and
        // drop any stale uuid so render() only routes once THIS join's
        // Members broadcast lands (the old '/play' target predated the
        // /game/:lobbyUuid wrapper and no longer resolves to a lobby).
        this.setState({ invitation: null, joining: true, lobbyUuid: null });
    };

    declineInvitation = () => {
        this.setState({ invitation: null });
    };

    list = (receivedMessage) => {
        // invitable friends
        if (!this.inviteToGroupButton) {
            // Ref hasn't settled yet (transient remount); the next
            // Group/List request will arrive after the child mounts.
            return;
        }
        this.inviteToGroupButton.receiveList(receivedMessage);
    };

    leave = () => {
        this.setState({ members: [] });
    }

    render() {
        if (this.state.launch) {
            let game = this.state.launch.game;
            let seat = this.state.launch.seat;
            return <Navigate to={`/game/${game}/?seat=${seat}`}/>;
        }

        // CC_FRIENDS_INVITE_FROM_LOBBY: an accepted invite routes to the
        // inviter's lobby once joinGroup's Members broadcast supplies the
        // uuid (see acceptInvitation / groupEvent). Canonical lobby
        // surface — the same /game/:lobbyUuid wrapper New Game and the
        // Live tiles use.
        if (this.state.joining && this.state.lobbyUuid) {
            return <Navigate to={`/game/${this.state.lobbyUuid}`}/>;
        }

        // CC_FRIENDS_INVITE_FROM_LOBBY: the invited friend is by
        // definition NOT yet in this group, so the accept toast must
        // render INDEPENDENT of the in-group gate below — otherwise the
        // invite is un-acceptable on the Main Menu (the friend's idle
        // surface), which is where GroupMenu is mounted off-lobby.
        const invitationToast = this.state.invitation && <InvitationToast
            {...this.props}
            {...this.state}
            acceptInvitation={this.acceptInvitation}
            declineInvitation={this.declineInvitation}
        />;

        let userId = this.props.app.state.authenticator.account.user.id;
        let userMember = this.state.member;
        // Phase C migration repair (2026-05-21): the legacy
        // UserConnection.group self-FK is gone. The Connection
        // message lands before the Members broadcast and installs an
        // {id} stub, so the gate must require a populated .user
        // (which IndividualMenu reads as .user.rank), not just an id.
        if (!userMember || !userMember.user) {
            return <>{invitationToast}</>;
        }
        return (<>
                {invitationToast}
                <div id={'group-menu-anchor'} className={'group-menu-anchor'}>
                    <div id={'group-menu-container'} className={'group-menu-container'}>
                        <InviteToGroupButton
                            {...this.props}
                            {...this.state}
                            ref={(r) => { this.inviteToGroupButton = r; }}
                        />
                        {this.state.members.map((member, memberKey) => {
                            if (member.user.id === userId) {
                                return <div key={memberKey}/>;
                            }
                            return <MemberMenu key={memberKey}
                                               {...this.props}
                                               {...this.state}
                                               displayMember={member} />;
                        })}
                        <IndividualMenu {...this.props}
                                        {...this.state}
                                        userMember={userMember}/>
                    </div>
                </div>
            </>
        );
    }
}
